import { Skeleton, Td, Tr } from '@chakra-ui/react';
import React from 'react'

interface Props {
    header: Header[]
}

interface Header {
    label: string,
    acessor: string,
    custom?: Function
}

const LoadingRows = ({ header }: Props) => {
    const loadingRows = [0, 1, 2, 3];

    return (
        <>
            {
                loadingRows.map((a, i) => (
                    <Tr key={`${a}_${i}`}>
                        {
                            header.map((b, i) => (
                                <Td key={`${b}_${i}`}>
                                    <Skeleton h={"20px"} />
                                </Td>
                            ))
                        }
                    </Tr>
                ))
            }
        </>
    )
}

export default LoadingRows